import { ModuleType } from '@fi-shared/types/module-type';
import { ObjectTypes } from '@fi-shared/types/object-type';

export const AppearanceModuleSideListOptions = [
    {
        textId: 'common.pages',
        moduleType: ModuleType.Document,
        objectType: ObjectTypes.Document,
        previewTemplateName: 'Document',
    },
    {
        textId: 'common.files',
        moduleType: ModuleType.MediaBank,
        objectType: ObjectTypes.MediaBank,
        previewTemplateName: 'MediaBank',
    },
    {
        textId: 'common.our_organisation',
        moduleType: ModuleType.Core,
        objectType: ObjectTypes.User,
        previewTemplateName: 'User',
    },
];
